<template>
  <v-card v-if="entries.length" outlined rounded="lg" class="pa-3 h-100">
    <div class="section-card-title">
      <v-icon color="#B3151B" class="mr-2">mdi-source-branch</v-icon>
      ผู้เรียนแยกตามสาขาวิชา
      <span class="section-card-count">{{ entries.length }} สาขา</span>
    </div>

    <apexchart type="bar" height="380" :options="chartOptions" :series="series"></apexchart>
  </v-card>
</template>

<script>
// รับข้อมูลจาก parent (collegesid.vue) — ดู stdLevel.vue สำหรับเหตุผลที่เลิก fetch เอง
export default {
  name: "DashboardOvecMasterStdMinor",
  props: {
    rows: { type: Array, default: () => [] }
  },
  computed: {
    entries() {
      const grouped = {};
      this.rows.forEach(r => {
        const key = (r.minorNameTh || "ไม่ระบุสาขาวิชา") + "|" + (r.gradeNameTh || "");
        if (!grouped[key]) {
          grouped[key] = { branch: r.minorNameTh || "ไม่ระบุสาขาวิชา", grade: r.gradeNameTh || "", sum: 0 };
        }
        grouped[key].sum += parseInt(r.cnt) || 0;
      });
      return Object.values(grouped);
    },
    series() {
      return [{ data: this.entries.map(e => e.sum) }];
    },
    chartOptions() {
      const labelText = this.entries.map(e => e.branch + " : " + e.grade + " : " + e.sum + " คน");
      return {
        chart: { type: "bar", height: 380 },
        plotOptions: {
          bar: { borderRadius: 10, barHeight: "100%", distributed: true, dataLabels: { position: "top" } }
        },
        colors: ["#B3151B", "#1B365D", "#A86400", "#424242", "#8E1014", "#9E9E9E", "#212121", "#E57373"],
        dataLabels: {
          enabled: true,
          formatter: val => val,
          offsetY: -20,
          style: { fontSize: "12px", colors: ["#B3151B"] }
        },
        stroke: { width: 1, colors: ["#fff"] },
        xaxis: { categories: labelText },
        yaxis: { axisBorder: { show: false }, axisTicks: { show: false }, labels: { show: false } },
        tooltip: { theme: "dark", x: { show: false }, y: { title: { formatter: () => "" } } }
      };
    }
  }
};
</script>

<style scoped>
.h-100 {
  height: 100%;
}
.section-card-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-weight: 700;
  color: #1b365d;
  font-size: 1rem;
  margin-bottom: 8px;
}
.section-card-count {
  margin-left: auto;
  font-weight: 700;
  color: #b3151b;
}
</style>
